<template>
    <el-dialog :close-on-click-modal="false" :visible.sync="show" align-center class="payino-dialog"
        width="750px" @close="close()">
        <div class="payinfo-form">
            <div class="modal">
                <div class="form">
                    <div class="separator">
                        <hr class="line">
                        <p>pay using credit card</p>
                        <hr class="line">
                    </div>
                    <div class="credit-card-info--form">
<!--                        <div class="input_container">
                            <label class="input_label" for="full_name">Card holder full name</label>
                            <input id="full_name" v-model="formData.name" class="input_field" name="input-name"
                                placeholder="Enter your full name" title="Inpit title" type="text">
                        </div>
                        <div class="input_container">
                            <label class="input_label" for="phone_number">Card holder phone number</label>
                            <input id="phone_number" v-model="formData.phone" class="input_field" name="input-name"
                                placeholder="Enter your phone number" title="Inpit title" type="number">
                        </div>-->
                        <div class="input_container">
                            <label class="input_label" for="card_number">Card number</label>
                            <input id="card_number" v-model="formData.cardNumberKeyValue" class="input_field" name="input-name"
                                placeholder="Enter your card number" title="Inpit title" type="number">
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="input_container">
                                    <label class="input_label" for="zip_code">Zip code</label>
                                    <input id="zip_code" v-model="formData.zip_code" class="input_field" name="input-name"
                                        placeholder="Enter your zip code" title="Inpit title" type="number">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="input_container">
                                    <label class="input_label" for="CVV">CVV</label>
                                    <input id="CVV" v-model="formData.cvv" class="input_field" name="input-name"
                                        placeholder="(e.g. 123)" title="Enter your CVV" type="number">
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="input_container">
                                    <label class="input_label" for="expire_year">Expire year</label>
                                    <input id="expire_year" v-model="formData.expireYear" class="input_field" name="input-name"
                                        placeholder="(e.g. 2025)" title="Inpit title" type="number">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="input_container">
                                    <label class="input_label" for="expire_month">Expire month</label>
                                    <input id="expire_month" v-model="formData.expireMonth" class="input_field" name="input-name"
                                        placeholder="(e.g. 05)" title="Inpit title" type="number">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <button class="purchase--btn" @click="confirm()">Checkout</button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        show: {
            require: true,
            default: false
        }
    },
    data() {
        return {
            formData: {

                zip_code: "",  // 户所在地区邮政编码。
                cvv: "",  // 信用卡背面的 3 位安全码。
                cardNumberKeyValue: "",  // 信用卡号。测试环境值固定为:4111111111111111
                expireYear: "",  // 信用卡的过期年份，格式为 `YYYY`
                expireMonth: "",  // 信用卡的过期月份，格式为`MM`
            },
            rules: [
                {key: 'cardNumberKeyValue', errMsg: 'Please enter your credit card number'},
                {key: 'zip_code', errMsg: 'Please enter the postal code of the region'},
                {key: 'cvv', errMsg: 'Please enter a 3-digit security code'},
                {key: 'expireYear', errMsg: 'Please enter the expiration year'},
                {key: 'expireMonth', errMsg: 'Please enter the expiration month'},
            ],
        }
    },
    created() {

    },
    methods: {
        confirm() {
            for (let index = 0; index < this.rules.length; index++) {
                const rule = this.rules[index];
                if (this.formData[rule.key] === '') {
                    this.$message.error(rule.errMsg)
                    return
                }
            }
            if(this.formData.cvv.length !=3){
              this.$message.error("CVV format incorrect (e.g. 123)")
              return
            }
            if(this.formData.expireYear.length !=4){
              this.$message.error("The expiration year format is incorrect (e.g. 2005)")
              return
            }
            if(this.formData.expireMonth.length !=2){
              this.$message.error("The expiration month format is incorrect (e.g. 05)")
              return
            }

            this.$emit('confirm', this.formData)
        },
        close() {
            this.formData = this.$options.data().formData
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>